<div class="rs-panel-flex">
  <div class="rs-panel-flex-cell rs-bg-grey1">
    <h3 class="rs-tit6">{{ 'aliases.component.title' | translate }}</h3>
    <div class="panel">
      <p>
        <strong>{{ 'aliases.current.aliases.title' | translate }}</strong>
      </p>
      <div class="rs-flex-row rs-flex-dir-col rs-flex-top-medium">
        <ng-container *ngFor="let alias of aliases$ | async">
          <mprd-alias-details
            [alias]="alias"
            (removeAlias)="onRemoveAlias($event)"
          ></mprd-alias-details>
        </ng-container>
      </div>
    </div>
    <div *ngIf="(remainingAliases$ | async) > 0">
      <div class="panel">
        <p>
          <strong>{{ remainingAliasesLabel$ | async }}</strong>
        </p>
        <mprd-create-alias
          [mailbox]="selectedMailbox$ | async"
          (createMailAlias)="onCreateAlias($event)"
          [showLoadingSpinner$]="showLoadingSpinner$"
        ></mprd-create-alias>
      </div>
    </div>
  </div>
</div>
